export const SOCIAL = {
  TWITTER_LOADING_FAILURE_TITLE: 'COMMON_SOCIAL_TWITTER_LOADING_FAILURE_TITLE',
  TWITTER_LOADING_FAILURE_MESSAGE:
    'COMMON_SOCIAL_TWITTER_LOADING_FAILURE_MESSAGE',
  TWITTER_PROFILE_ALT_LABEL: 'COMMON_SOCIAL_TWITTER_PROFILE_ALT_LABEL',
  SHARE: 'COMMON_SOCIAL_SHARE',
  SHARE_BY_EMAIL: 'COMMON_SOCIAL_SHARE_BY_EMAIL',
  SHARE_BY_EMAIL_BODY: 'COMMON_SOCIAL_SHARE_BY_EMAIL_BODY',
  SHARE_BY_EMAIL_SUBJECT: 'COMMON_SOCIAL_SHARE_BY_EMAIL_SUBJECT',
  SN_ACCESS_TO: 'COMMON_SOCIAL_SN_ACCESS_TO',
  SN_REGIONAL_TWITTER_LABEL: 'COMMON_SOCIAL_SN_REGIONAL_TWITTER_LABEL',
  SN_SHARE_ON: 'COMMON_SOCIAL_SN_SHARE_ON',
};
